import { BoardType } from '@/constants';
import React from 'react';

export const NoMealIcon = ({
  additionalIcon,
  ...props
}: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & { additionalIcon?: React.ReactElement }) => {
  return (
    <span className="board-type-icon no-meal">
      <img src="/static/icons/no-food.png" alt="No meal " {...props} style={{ width: 25 }} />
      {BoardType.__getValue(BoardType.NoMeals)} {additionalIcon ? additionalIcon : null}
    </span>
  );
};

export const BreakfastIncludeIcon = ({
  additionalIcon,
  ...props
}: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & { additionalIcon?: React.ReactElement }) => {
  return (
    <div className="board-type-icon breakfast">
      <img src="/static/icons/cup.png" alt="Breakfast Incl " {...props} />
      {BoardType.__getValue(BoardType.BreakfastIncl)} {additionalIcon ? additionalIcon : null}
    </div>
  );
};

export const DinnerOnlyIcon = ({
  additionalIcon,
  ...props
}: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & { additionalIcon?: React.ReactElement }) => {
  return (
    <div className="board-type-icon dinner">
      <img src="/static/icons/fork.png" alt="Dinner only " {...props} />
      {BoardType.__getValue(BoardType.DinnerOnly)} {additionalIcon ? additionalIcon : null}
    </div>
  );
};

export const BreakfastIncludeDinnerOnlyIcon = ({
  additionalIcon,
  ...props
}: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & { additionalIcon?: React.ReactElement }) => {
  return (
    <div className="board-type-icon breakfast-dinner">
      <img src="/static/icons/fork.png" alt="Breakfast and dinner included " {...props} />
      {BoardType.__getValue(BoardType.DinnerAndBreakfastIncl)}
      {additionalIcon ? additionalIcon : null}
    </div>
  );
};
